module.exports = __webpack_public_path__ + "media/images/crm/chart-background-e557205441d1bb7b44380326dbc668af.png";